import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import type { Language } from '../../types_i18n';
import './LegalPage.css';

const OPTIONS: { code: Language; flag: string; label: string }[] = [
  { code: 'nl', flag: '🇳🇱', label: 'Nederlands' },
  { code: 'en', flag: '🇬🇧', label: 'English' },
  { code: 'ar', flag: '🇸🇦', label: 'العربية' },
];

export default function LanguagePage() {
  const navigate = useNavigate();
  const { t, currentLanguage: language, setLanguage } = useLanguage();

  const select = (lang: Language) => {
    setLanguage(lang);
    try {
      localStorage.setItem('preferredLanguage', lang);
      document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
      document.documentElement.setAttribute('lang', lang);
    } catch {
      // ignore
    }
    navigate('/dashboard');
  };

  const title = language === 'nl' ? 'Taal' : language === 'ar' ? 'اللغة' : 'Language';
  const backLabel = language === 'nl' ? '← Terug' : language === 'ar' ? '← رجوع' : '← Back';

  return (
    <div className="legal-page">
      <div className="legal-page-header">
        <button
          type="button"
          className="legal-page-back"
          onClick={() => navigate('/dashboard')}
          aria-label={t('aria.goBack')}
        >
          {backLabel}
        </button>
        <h1 className="legal-page-title">{title}</h1>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '8px' }}>
        {OPTIONS.map(({ code, flag, label }) => (
          <button
            key={code}
            type="button"
            onClick={() => select(code)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '14px',
              padding: '14px 18px',
              borderRadius: '12px',
              border: language === code ? '2px solid #1a3a5c' : '2px solid #e5e7eb',
              background: language === code ? '#f0f4f8' : '#ffffff',
              cursor: 'pointer',
              fontFamily: 'var(--font-primary)',
              fontSize: '16px',
              fontWeight: language === code ? 700 : 500,
              color: '#1a3a5c',
              textAlign: 'left',
            }}
          >
            <span style={{ fontSize: '24px', flexShrink: 0 }}>{flag}</span>
            <span style={{ flex: 1 }}>{label}</span>
            {language === code && (
              <span style={{ color: '#1a3a5c', fontSize: '18px' }}>✓</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
